(() => {
  angular.module('app.components', ['app.core']);
})();
